<template>
  <div>
    <h2>Фактическая оплата</h2>
    <br>
    <div class="row g-3">

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='2024' step="1" class="form-control" id="accountingYear" v-model="searchParam.filter.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список бинов:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.filter.binList"
                    required
                    placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список LMS ID:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.filter.lmsIdList"
                    required
                    placeholder="1-1-1, 1-1-2, ...
или
1-1-1
1-1-2
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchKindergartenActReconciliation(true)">Поиск</button>
          <button class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4">
        <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParam.countInPage"></b-pagination>
      </div>
    </div>
    <el-table :data="kindergartenActReconciliation" style="width: 100%">
      <el-table-column type="index" label="#" width="50"></el-table-column>
      <el-table-column label="БИН ДО" prop="report.bin"></el-table-column>
      <el-table-column label="LMS ID" prop="lmsId"></el-table-column>
      <el-table-column label="Название файла">
        <template #default="scope">
          <a
              @click="handleDownload(scope.row.report.uuid, scope.row.report.fileName)"
              :class="{ 'active-link': scope.row.report.reportStatus === 'GENERATED', 'error-link': scope.row.report.reportStatus === 'ERROR' }"
          >
            {{ scope.row.report.fileName }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Расчетный год" prop="accountingYear"></el-table-column>
      <el-table-column label="Статус">
        <template #default="scope">
          <div v-if="scope.row.status === KindergartenActReconciliationStatus.UPLOADED">
            <button type="button" class="btn btn-success" @click="acceptKindergartenActReconciliation(scope.row.id)" :disabled="isLoading">{{ isLoading ? "Загрузка..." : "Принять"}}</button>
            <button type="button" class="btn btn-danger" @click="rejectKindergartenActReconciliation(scope.row.id)" :disabled="isLoading">{{ isLoading ? "Загрузка..." : "Отклонить"}}</button>
          </div>
          <div v-else-if="scope.row.status === KindergartenActReconciliationStatus.REJECTED" class="error-status">
            <span>Отклонено! {{ scope.row.comment && scope.row.comment != "" ? "Коммент: "+scope.row.comment : "" }}</span>
<!--            <a type="button" class="btn btn-sm btn-link">Принять</a>-->
          </div>
          <div v-else-if="scope.row.status === KindergartenActReconciliationStatus.ACCEPTED" class="success-status">
            <span>Принято!</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="showRejectKindergartenActReconciliationModal" class="modal">
      <div class="modal-content">
        <h2>Отказ от акта</h2>
        <form @submit.prevent="changeStatusOfKindergartenActReconciliation(KindergartenActReconciliationStatus.REJECTED)">
          <b-form-group label="Укажите причину отказа">
            <b-form-textarea v-model="rejectComment"></b-form-textarea>
          </b-form-group>
          <b-button type="submit" variant="primary" :disabled="isLoading">
            {{ isLoading ? 'Сохраняется...' : 'Сохранить' }}
          </b-button>
        </form>
        <button class="close-modal-btn" @click="showRejectKindergartenActReconciliationModal = false">Закрыть</button>
      </div>
    </div>

    <div v-if="showAcceptKindergartenActReconciliationModal" class="modal">
      <div class="modal-content">
        <h2>Вы уверены что хотите принять акт?</h2>
        <form @submit.prevent="changeStatusOfKindergartenActReconciliation(KindergartenActReconciliationStatus.ACCEPTED)">
          <b-button type="submit" variant="primary" :disabled="isLoading">
            {{ isLoading ? 'Сохраняется...' : 'Сохранить' }}
          </b-button>
        </form>
        <button class="close-modal-btn" @click="showAcceptKindergartenActReconciliationModal = false">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, reactive, ref, watch} from "vue";
import Multiselect from "vue-multiselect";
import {SearchParam} from "@/types/searchParam";
import {Kato, KindergartenActReconciliation} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import {changeKindergartenActReconciliationStatus, getDataListByParam} from "@/services/kindergartenService";
import {PageResponse} from "@/types/pageResponse";
import {KindergartenActReconciliationStatus} from "@/enums/Kindergarten";
import {downloadReportFile} from "@/services/reportService";

export default defineComponent({
  computed: {
    KindergartenActReconciliationStatus() {
      return KindergartenActReconciliationStatus
    }
  },
  components: {Multiselect},
  setup() {
    const searchParam = reactive(new SearchParam(10, 1, {accountingYear: new Date().getFullYear(), lmsIdList: "", binList: "", katoCode: ""}, {}));
    const kato = ref<Kato | null>(null);
    const katoList = ref<Kato[]>([]);
    const isLoading = ref(false);
    const pageResponse = ref<PageResponse<KindergartenActReconciliation>>();
    const kindergartenActReconciliation = ref<KindergartenActReconciliation[]>();
    const currentPage = ref(1);
    const selectedKindergartenActReconciliationId = ref<number>();
    const showRejectKindergartenActReconciliationModal = ref(false);
    const rejectComment = ref<string>("");
    const showAcceptKindergartenActReconciliationModal = ref(false);

    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const clearSearchParam = () => {
      kato.value = null;
      searchParam.filter.accountingYear = null;
      searchParam.filter.binList = "";
      searchParam.filter.lmsIdList = "";
      searchParam.filter.katoCode = "";
    }

    const fetchKindergartenActReconciliation = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParam.partNumber = 1;
          currentPage.value = 1;
        }
        pageResponse.value = await getDataListByParam(searchParam);
        kindergartenActReconciliation.value = pageResponse.value.content;
      } catch (error) {
        console.error("Error on fetching kindergarten act reconciliation");
        throw error;
      }
    }

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    const kindergartenActReconciliationStatus = (status: KindergartenActReconciliationStatus) => {
      if (status === KindergartenActReconciliationStatus.UPLOADED) {
        return "Загружен";
      } else if (status === KindergartenActReconciliationStatus.ACCEPTED) {
        return "Принято";
      } else if (status === KindergartenActReconciliationStatus.REJECTED) {
        return "Отказано от ФЦ";
      }
      return "Неизвестная ошибка";
    }

    const acceptKindergartenActReconciliation = (kindergartenActReconciliationId: number) => {
      selectedKindergartenActReconciliationId.value = kindergartenActReconciliationId;
      rejectComment.value = "";
      showAcceptKindergartenActReconciliationModal.value = true;
    }

    const rejectKindergartenActReconciliation = (kindergartenActReconciliationId: number) => {
      selectedKindergartenActReconciliationId.value = kindergartenActReconciliationId;
      showRejectKindergartenActReconciliationModal.value = true;
    }

    const changeStatusOfKindergartenActReconciliation = async(status: KindergartenActReconciliationStatus) => {
      try {
        isLoading.value = true;
        if (selectedKindergartenActReconciliationId && selectedKindergartenActReconciliationId.value !== undefined) {
          let request: KindergartenActReconciliation = await changeKindergartenActReconciliationStatus(
              selectedKindergartenActReconciliationId.value,
              status,
              rejectComment.value
          );

          let index = kindergartenActReconciliation.value !== undefined ? kindergartenActReconciliation.value.findIndex((item) => item && selectedKindergartenActReconciliationId && item.id === selectedKindergartenActReconciliationId.value) : -1;
          if (index !== -1 && kindergartenActReconciliation.value && kindergartenActReconciliation.value[index]) {
            kindergartenActReconciliation.value[index] = request;
          }
          isLoading.value = false;
          showRejectKindergartenActReconciliationModal.value = false;
          showAcceptKindergartenActReconciliationModal.value = false;
        }
      } catch (error) {
        console.error("error on changing status");
      }
    }

    watch(currentPage, (newPage) => {
      currentPage.value = newPage;
      searchParam.partNumber = newPage;
    });

    onMounted(() => {
      fetchCachedData();
    });

    return {
      searchParam,
      kato,
      katoList,
      isLoading,
      currentPage,
      kindergartenActReconciliation,
      showRejectKindergartenActReconciliationModal,
      rejectComment,
      pageResponse,
      showAcceptKindergartenActReconciliationModal,
      fetchCachedData,
      formattedKatoLabel,
      clearSearchParam,
      fetchKindergartenActReconciliation,
      handleDownload,
      kindergartenActReconciliationStatus,
      acceptKindergartenActReconciliation,
      rejectKindergartenActReconciliation,
      changeStatusOfKindergartenActReconciliation,
    }
  }
});
</script>

<style scoped>
.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}


h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

.success-status {
  color: green;
}

.error-status {
  color: red;
}
</style>